export default __webpack_public_path__ + "static/media/logo.63c80878.png";